import { SubscriptionSetPaymentStatus } from "./subscription-set-payment";

export class SubscriptionSet {
    id: string;
    type: SubscriptionSetType;
    customerId: string;
    partnerId: string;
    activationTimestamp: number;
    duration: SubscriptionSetDuration;
    subscriptionThings: SubscriptionThing[];
    subscriptionPlan: SubscriptionDigitalService;
    subscriptionAddOns: SubscriptionDigitalService[];
    renewalFee: number;
    undiscountedRenewalFee: number;
    renewalTimestamp: number;
    status: SubscriptionSetStatus;
    paymentStatus: SubscriptionSetPaymentStatus;
    pendingPaymentCount: number;
    discountPercentage: number;
    // enriched fields
    config: DigitalServiceConfiguration;
    plans: DigitalService[];
    addOns: DigitalService[];
    features: DigitalServiceFeature[];
    paymentMethod: SubscriptionSetPaymentMethod;
    segments: DigitalServiceConfigurationSegment[];
}

export class SubscriptionThing {
    thingId: string;
    subscriptionPlan: SubscriptionDigitalService;
    subscriptionAddOns: SubscriptionDigitalService[];
}

export class SubscriptionDigitalService {
    digitalServiceId: string;
    replacingDigitalServiceId: string;
    deactivating: boolean;
}

export enum SubscriptionSetType {
    CUSTOMER = 'CUSTOMER',
    PARTNER = 'PARTNER'
}

export enum SubscriptionSetDuration {
    YEAR_1 = 'YEAR_1'
}

export class DigitalServiceConfiguration {
    id: string;
    type: DigitalServiceConfigurationType;
    trialPeriod: boolean;
    trialPeriodMonths: number;
    trialPeriodAvailability: DigitalServiceTrialPeriodAvailability;
    trialPeriodPlanId: string;
    trialPeriodAddOnIds: string[];
    activationMode: DigitalServiceActivationMode;
}

export class DigitalService {
    id: string;
    type: DigitalServiceType;
    digitalServiceConfigurationId: string;
    name: string;
    label: string;
    description: string;
    featureIds: string[];
    defaultRecurringFee: number;
    productModelRecurringFees: DigitalServiceProductModelFee[];
    temporaryAccess: boolean;
    temporaryAccessDays: number;
    temporaryAccessActivationFee: number;
    temporaryAccessProductModelActivationFees: DigitalServiceProductModelFee[];
    orderIndex: number;
    defaultPlan: boolean;
    rawDataRetentionMonths: number;
}

export interface DigitalServiceFeature {
    id: string;
    digitalServiceConfigurationId: string;
    name: string;
    label: string;
    description: string;
    orderIndex: number;
    predefined: boolean;
}

export enum DigitalServiceConfigurationType {
    CUSTOMER = 'CUSTOMER',
    PARTNER = 'PARTNER',
    DATA_RECIPIENT = 'DATA_RECIPIENT'
}

export enum DigitalServiceActivationMode {
    BY_CUSTOMER = 'BY_CUSTOMER',
    BY_PARTNER = 'BY_PARTNER',
    BY_THING = 'BY_THING'
}

export enum DigitalServiceTrialPeriodAvailability {
    FIRST_ACTIVATION_ONLY = 'FIRST_ACTIVATION_ONLY',
    ANY_ACTIVATION = 'ANY_ACTIVATION'
}

export enum DigitalServiceType {
    PLAN = 'PLAN',
    ADD_ON = 'ADD_ON'
}

export interface DigitalServiceProductModelFee {
    productModelId: string;
    configurations: DigitalServiceProductModelFeeConfiguration[];
}

export interface DigitalServiceProductModelFeeConfiguration {
    segmentId: string | null;
    fee: number;
    disabled: boolean;
}

export enum SubscriptionSetStatus {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED'
}

export class SubscriptionSummary {
    paidSubscriptionCount: number;
    suspendedSubscriptionCount: number;
    renewalFee: number;
    planCounts: DigitalServiceCount[];
    addOnCounts: DigitalServiceCount[];
}

export class DigitalServiceCount {
    label: string;
    count: number;
}

export class SubscriptionSetPaymentMethod {
    type: string;
    cardBrand: string;
    cardExpirationYear: number;
    cardExpirationMonth: number;
    cardLast4Digits: string;
    valid: boolean;
}

export interface DigitalServiceConfigurationSegment {
    id: string;
    digitalServiceConfigurationId: string;
    name: string;
    label: string;
    countries: string[];
}